import Toast from '@/lib/toast'
import Vue from 'vue'
import VuetifyToast from 'vuetify-toast-snackbar'
import Vuetify, { VBtn, VIcon, VSnackbar } from 'vuetify/lib'
import de from '@/locale/de.ts'
import en from '@/locale/en.ts'
import es from '@/locale/es.ts'
import ja from '@/locale/ja.ts'
import pt from '@/locale/pt.ts'
import pl from '@/locale/pl.ts'
import ru from '@/locale/ru.ts'
import th from '@/locale/th.ts'

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
  },
})

// Toast
Vue.use(VuetifyToast, Toast.defaultOptions())

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        'aid-bg-grey': '#F5F5F5',
        'aid-bg-darkgrey': '#edeced',

        primary: '#0d7085',
        secondary: '#6c757d',
        accent: '#99674e',
        //   error: '#FF5252',
        //   info: '#2196F3',
        //   success: '#4CAF50',
        //   warning: '#FFC107'
      },
      dark: {
        'aid-bg-grey': '#424242',

        primary: '#19957a',
        secondary: '#6c757d',
        //   accent: '#82B1FF',
        //   error: '#FF5252',
        //   info: '#2196F3',
        //   success: '#4CAF50',
        //   warning: '#FFC107'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: {
      de,
      ja,
      en,
      es,
      pt,
      pl,
      ru,
      th,
    },
  },
})
